import { spadesDescriptor } from '@cardforest/games/games/spades/descriptor.js';
import { CardVignette, MiniPlayingCard, SuitGlyph } from '../discovery/cards.js';
import type { GameDiscoveryPresentation } from '../discovery/types.js';

export const spadesDiscoveryPresentation = {
  gameId: spadesDescriptor.gameId,
  Icon: ({ className }) => <SuitGlyph suit="spades" className={className} />,
  Thumbnail: () => (
    <CardVignette>
      <MiniPlayingCard rank="K" suit="spades" className="-rotate-8 -translate-x-2 translate-y-0.5" />
      <MiniPlayingCard rank="A" suit="spades" className="z-10 rotate-8 translate-x-2 -translate-y-0.5" />
    </CardVignette>
  ),
} satisfies GameDiscoveryPresentation;
